import React, { useState } from "react"
import moment from 'moment'
import Toggle from "components/inputs/Toggle"
import utils from 'components/utils/utils'

import styles from "./style.module"

const TrustCenterEdit = ({
  companySlug,
  trustCenter,
}) => {
  const [published, setPublished] = useState(trustCenter.published)
  const [lastPublishedAt, setLastPublishedAt] = useState(trustCenter.lastPublishedAt)
  const [copyText, setCopyText] = useState('Copy Link')
  const url = `${window.location.protocol}//${window.location.hostname}/p/${companySlug}/trust_center`

  const togglePublishStatus = (published) => {
    const data = { published }
    if (published) {
      data.last_published_at = moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
    }
    fetch(`/trust_centers/${trustCenter.slug}`, {
      method: 'PATCH',
      body: JSON.stringify({
        trust_center: data
      }),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': utils.csrfToken()
      }
    }).then(res => res.json())
      .then(response => {
        setPublished(response.published)
        setLastPublishedAt(response.lastPublishedAt)
      })
      .catch(errors => setResponseErrors(errors))
  }

  const copyLink = () => {
    navigator.clipboard.writeText(url)
    setCopyText('Copied!')
    setTimeout(() => {
      setCopyText('Copy Link')
    }, 2000);
  }

  return trustCenter && <div className={`content has-dark-background ${styles.trustCenterEdit}`}>
    {published && <div className={`columns ${styles.columns}`}>
      <div className="column" style={{ margin: '0 -12px' }}>
        <div className={`is-flex is-align-items-center is-justify-content-space-between ${styles.published}`}>
          <div className="is-flex is-align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <polygon fill="#2BC9B4" fillRule="evenodd" points="9 16.17 4.83 12 3.41 13.41 9 19 21 7 19.59 5.59" />
            </svg>
            <span style={{ paddingLeft: '10px' }}>Published {lastPublishedAt}</span>
          </div>
          <div className="is-flex is-align-items-center">
            <b>
              {copyText == 'Copy Link' && <a style={{ marginRight: '10px' }} onClick={() => copyLink()}>{copyText}</a>}
              {copyText == 'Copied!' && <span style={{ marginRight: '10px' }}>{copyText}</span>}
            </b>
            <b><a href={url} target="_blank" className="is-flex is-align-items-center">
              View
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style={{ height: '18px' }}>
                <path fill="#0075E0" fillRule="evenodd" d="M19,19 L5,19 L5,5 L12,5 L12,3 L5,3 C3.89,3 3,3.9 3,5 L3,19 C3,20.1 3.89,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,12 L19,12 L19,19 Z M14,3 L14,5 L17.59,5 L7.76,14.83 L9.17,16.24 L19,6.41 L19,10 L21,10 L21,3 L14,3 Z" />
              </svg>
            </a>
            </b>
          </div>
        </div>
      </div>
    </div>}

    <div className={`columns ${styles.columns}`}>
      <div className="column" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <div className={styles.card}>
          <Toggle
            label={'Publish'}
            initialValue={trustCenter.published}
            onChange={value => togglePublishStatus(value)}
            options={[{ label: 'On', value: true }, { label: 'Off', value: false }]}
            subtitle={'Enable your Trust Center'} />
        </div>
      </div>
    </div>
  </div>
}

export default TrustCenterEdit
